<template>
  <div class="table-responsive">
    <table class="table table-striped">
      <Sortable
        :list="items"
        item-key="id"
        tag="tbody"
        :options="{handle:'.draggable-handle'}"
        @end="updateOrder"
      >
        <template #item="{element: criteria, index}">
          <tr v-bind:key="criteria.id">
            <td style="width: 20px">
              <span class="draggable-handle">
                <i class="fa fa-sort" aria-hidden="true"></i>
              </span>
            </td>

            <td class="text-muted"  style="width: 20px">
              <svg v-if="criteria.type === 'rating'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="m12 15.4l-3.76 2.27l1-4.28l-3.32-2.88l4.38-.38L12 6.1l1.71 4.04l4.38.38l-3.32 2.88l1 4.28z" opacity=".3"/><path fill="currentColor" d="m22 9.24l-7.19-.62L12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21L12 17.27L18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27l1-4.28l-3.32-2.88l4.38-.38L12 6.1l1.71 4.04l4.38.38l-3.32 2.88l1 4.28L12 15.4z"/></svg>
              <svg v-if="criteria.type === 'select'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32"><path fill="currentColor" d="M26 6V2H2v10h9v18h19V6ZM4 10V4h20v2H11v4Zm24 18H13V8h15Z"/><path fill="currentColor" d="M15 11h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7zm-4 6h2v2h-2zm4 0h7v2h-7z"/></svg>
              <svg v-if="criteria.type === 'checkbox'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 19H5V5h10V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8h-2M7.91 10.08L6.5 11.5L11 16L21 6l-1.41-1.42L11 13.17z"/></svg>
              <svg v-if="criteria.type === 'text'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M17 7h5v10h-5v2a1 1 0 0 0 1 1h2v2h-2.5c-.55 0-1.5-.45-1.5-1c0 .55-.95 1-1.5 1H12v-2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2V2h2.5c.55 0 1.5.45 1.5 1c0-.55.95-1 1.5-1H20v2h-2a1 1 0 0 0-1 1v2M2 7h11v2H4v6h9v2H2V7m18 8V9h-3v6h3Z"/></svg>
              <svg v-if="criteria.type === 'textarea'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75ZM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V5.75ZM7.25 9a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5Zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z"/></svg>
              <svg  v-if="criteria.type === 'upload'"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01L12.01 11z"/></svg>
            </td>

            <td>
              <a :href="editLink(criteria.id)">
                {{criteria.reference}}
              </a>
            </td>
            <td>
              <div class="tw:flex tw:flex-wrap tw:gap-2">
                <LocaleStatusBadge
                  v-for="(translationStatus, index) in criteria.translation_status"
                  :key="index"
                  size="sm"
                  :locale="translationStatus.locale"
                  :completed="translationStatus.status"
                />
              </div>
            </td>
            <td>
              <span class="badge badge-light" v-if="criteria.required">
                <i class="fa fa-check-circle" aria-hidden="true"></i> required
              </span>
            </td>
            <td>
              <span :class="[
                  criteria.is_active ? 'text-success' : 'text-danger',
                ]">
                <i class="fa fa-circle" aria-hidden="true"></i>
              </span>
            </td>
          </tr>
        </template>
      </Sortable>
    </table>
  </div>
</template>
<script>
import { Sortable } from "sortablejs-vue3";
import LocaleStatusBadge from "@/components/ui/LocaleStatusBadge.vue";
export default {
  components: {
    Sortable,
    LocaleStatusBadge,
  },
  data() {
    return{
      items: [],
    }
  },
  props: [
    'criterias',
    'editUrl',
    'orderUrl',
  ],
  methods: {
    editLink(id) {
      return _.replace(this.editUrl, ':id', id);
    },
    updateOrder(event) {
      this.items.splice(event.newIndex, 0, this.items.splice(event.oldIndex, 1)[0]);

      axios.post(this.orderUrl, {
        order: this.items.map((item) => item.id)
      })
        .catch(function(error) {
          alert(error);
        });
    }
  },
  mounted() {
    this.items = this.criterias;
  }
}
</script>